import http from '../../../utils/services/http'

export const list = (bem, limit = 100, page = 1, filtros = '') => {
    let url
    if (typeof bem !== 'undefined' && bem) {
        url = `/api/bem/${bem}/propostas?page=` + page + '&limit=' + limit + filtros
    } else {
        url = `/api/bem/propostas?page=` + page + '&limit=' + limit + filtros
    }
    return http.get(url)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const find = (bem, id) => {
    let url
    if (typeof bem !== 'undefined' && bem) {
        url = `/api/bem/${bem}/propostas/${id}`
    } else {
        url = `/api/bem/propostas/${id}`
    }
    return http.get(url)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const newProposta = (bem, data) => {
    let url = `/api/bem/${bem}/propostas`
    return http.post(url, data)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const updateProposta = (bem, proposta, method = 'PUT') => {
    let url = `/api/bem/${bem}/propostas/${proposta.id}`
    let _method = http.put
    if (method === 'PATCH') {
        _method = http.patch
    }
    return _method(url, proposta)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const deleteProposta = (bem, id) => {
    let url
    if (typeof bem !== 'undefined' && bem) {
        url = `/api/bem/${bem}/propostas/${id}`
    } else {
        url = `/api/bem/propostas/${id}`
    }
    return http.delete(url)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}
